<script lang="ts">
	import cn from 'classnames';
	import Tick from '$lib/images/svg/tick.svelte';
	import {createEventDispatcher} from "svelte";
	export let id: string;
	export let value: boolean;
	export let checked: boolean;
	export let isEshopFilter: boolean = false;
	export let isDisabled: boolean = false;
	
	const dispatch = createEventDispatcher();
	
	function handleChange(event: any) {
		dispatch('change', event);
	}
</script>

<div class={cn('inline-flex items-center', $$props.class)}>
	<label class="relative flex cursor-pointer items-center" for={id}>
		<input
			type="checkbox"
			class={cn(
				"before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none border border-gray-geyser transition-all",
				isEshopFilter ? 'bg-white' : 'checked:border-yellow checked:bg-yellow'
			)}
			{id}
			bind:value
			bind:checked
			on:change={handleChange}
			disabled={isDisabled}
		/>
		<span
			class={cn(
				'pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 opacity-0 peer-checked:opacity-100',
				isEshopFilter ? 'text-gray-shark' : 'text-white'
			)}
		>
			<Tick class="h-4 w-4" />
		</span>
	</label>
	<label class="cursor-pointer select-none text-gray-shark" for={id}>
		<slot name="label" />
	</label>
</div>
